// extracted by mini-css-extract-plugin
export default {"reportTable":"wsNJ1QICflIsXEC9LOX5"};